import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  deviceContainer: {
    width: '100%',
    marginTop: theme.spacing(2),
  },
  headContain: {
    width: '100%',
    display: 'flex',
    justifyContent: 'left',
    marginBottom: theme.spacing(3),
  },
}));

export { useStyles };
